import createLucideIcon from '../createLucideIcon';

const Wallet = createLucideIcon('Wallet', [
  ['path', { d: 'M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h12v4', key: 'st805m' }],
  ['path', { d: 'M4 6v12c0 1.1.9 2 2 2h14v-4', key: '16cu1e' }],
  ['path', { d: 'M18 12a2 2 0 0 0-2 2c0 1.1.9 2 2 2h4v-4h-4z', key: 'lwd56p' }],
]);

export default Wallet;
